import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { NAVADMIN, NAVEMP, NAVTHAIPOST } from "../utils";
import { getToken } from "../services";
import axios from "axios";
import { LuCheckCircle } from "react-icons/lu";

const Navbar = ({ openMenu }) => {
  const [loading, setLoading] = useState(true);
  const [nav, setNav] = useState(NAVEMP);

  const getRole = React.useCallback(async () => {
    const token = getToken();
    const headers = {
      "Content-Type": "application/json",
      id_token: token.idToken,
      access_token: token.accessToken,
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/roles/get-role-approve`,
        {
          headers: headers,
        }
      );
      if (response.data?.approvePage) {
        const titleToCheck = "รายการรออนุมัติ";
        const exists = NAVEMP.some(item => item.title === titleToCheck);
        if (!exists) {
          NAVEMP.unshift({
            title: titleToCheck,
            path: "/employee/approve",
            icon: LuCheckCircle,
          });
        }
      }
      
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getRole();
    const jsonEmp = JSON.parse(localStorage.getItem('adminRole') ?? '[]')[0]?.email ?? null;
    const path = window.location.pathname.split("/")[1];
    if (path === "admin") {
      if (jsonEmp === "thaipost.admin01@siamkubota.co.th") {
        setNav(NAVTHAIPOST);
      } else setNav(NAVADMIN);
    } else setNav(NAVEMP);
  }, [getRole]);

  return (
    <>
      {loading ? (
        <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
          <svg
            aria-hidden="true"
            className="inline w-12 h-12 text-gray-200 animate-spin dark:text-borderLine fill-secondary"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <section className="flex gap-6">
          <div
            className={`bg-slate-50 z-10 min-h-screen md:static absolute border-r ${
              openMenu ? "w-64" : "w-[72px] md:opacity-100 opacity-0"
            } duration-500 px-4 font-sarabun`}
          >
            <div className="mt-32 flex flex-col gap-4 relative">
              {nav?.map((menu, i) => (
                <Link
                  to={menu?.path}
                  key={i}
                  className={` ${
                    menu?.margin && "mb-5 border-b-4 borderLine"
                  } ${
                    menu?.color
                  } group flex items-center gap-3.5 p-2 hover:bg-hoverBackground rounded-md`}
                >
                  <div>{React.createElement(menu?.icon, { size: "23" })}</div>
                  <h2
                    className={`whitespace-pre duration-500 ${
                      !openMenu && "opacity-0 translate-x-28 overflow-hidden"
                    }`}
                  >
                    {menu?.title}
                  </h2>
                  <h2
                    className={`${openMenu && "hidden"} ${
                      menu?.color
                    } absolute left-48 bg-hoverBackground whitespace-pre rounded-md drop-shadow-lg px-0 py-0 w-0 overflow-hidden group-hover:px-2 group-hover:py-1 group-hover:left-14 group-hover:duration-300 group-hover:w-fit  `}
                  >
                    {menu?.title}
                  </h2>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Navbar;
